import React from 'react';
import './KPICard.css';

function KPICard({ title, value, subtitle, icon, trend, trendDirection }) {
  const getTrendIcon = () => {
    if (trendDirection === 'up') return '↑';
    if (trendDirection === 'down') return '↓';
    return '→';
  };

  const getTrendClass = () => {
    if (trendDirection === 'up') return 'trend-up';
    if (trendDirection === 'down') return 'trend-down';
    return 'trend-neutral';
  };

  return (
    <div className="kpi-card">
      <div className="kpi-header">
        <span className="kpi-icon">{icon}</span>
        {trend && (
          <span className={`kpi-trend ${getTrendClass()}`}>
            {getTrendIcon()} {trend}
          </span>
        )}
      </div>
      <div className="kpi-body">
        <h3 className="kpi-title">{title}</h3>
        <div className="kpi-value">{value}</div>
        <p className="kpi-subtitle">{subtitle}</p>
      </div>
    </div>
  );
}

export default KPICard;
